import Audio from '../../../message-types/audio/Audio.component';
import { AudioBallonProps } from './index';

export function AudioPlayer(props: Readonly<AudioBallonProps>) {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
      }}
    >
      {/* Audio player */}
      <div className="audioMessage">
        <Audio
          urlBase64={props.messageProps.urlBase64}
          errorMessage={props.messageProps.errorMessage}
          messageId={props.messageProps.messageId}
          isLoading={props.isLoading}
          urlMedia={props.urlMedia}
          mimeType={props.messageProps.mimeType}
          authorName={props.messageProps.authorMessage}
          messageTime={props.messageProps.time}
          messageDirection={props.messageProps.direction}
          reply_message={props.reply_message}
        />
      </div>
    </div>
  );
}
